import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import type { LearnerFeatureGates } from '@examflow/api';
import { usePlatformSettings } from './PlatformSettingsContext';

export function LearnerGateRoute({
  gate,
  children,
}: {
  gate: keyof LearnerFeatureGates;
  children: ReactNode;
}) {
  const { learnerGates, isLoading } = usePlatformSettings();
  if (isLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-slate-200 border-t-slate-600" />
      </div>
    );
  }
  if (!learnerGates[gate]) {
    return <Navigate to="/workspace" replace />;
  }
  return <>{children}</>;
}

export function AnnouncementBanner() {
  const { announcement } = usePlatformSettings();
  if (!announcement.enabled) return null;
  return (
    <div
      role="status"
      className="border-b border-amber-200 bg-amber-50 px-4 py-2 text-center text-sm text-amber-950"
    >
      {announcement.message}
    </div>
  );
}
